
document.addEventListener("DOMContentLoaded", () => {
    getAnnouncementBarHeight();

    window.onresize = function (){

    }
})

function getAnnouncementBarHeight(){
  const announcementBar = document.querySelector('[id*="shopify-section-sections--"][id*="__announcement-bar"]');
  if (announcementBar){
      document.documentElement.style.setProperty("--announcement-bar-height", announcementBar.offsetHeight );
  }
}

function handleFullScreenBanner(){
    let ratio =  window.innerWidth / window.innerHeight;
}

function addCarouselDots (parentEl, dots) {
    const dotsFragment = document.createDocumentFragment();
    for (let i = 0; i < dots; i++) {
        const dot = document.createElement("button");
        dot.className = "carousel-dot";
        if (i === 0) dot.classList.add("active");
        dotsFragment.appendChild(dot);
    }
    parentEl.appendChild(dotsFragment);
}

